module.exports = __webpack_public_path__ + "img/map.c7f93fdd.jpg";